import { StudentLayout } from '@/components/layout/student'
import { useStudentAuth } from './hook/use-student-auth'

export const StudentAuthPage = () => {
  useStudentAuth()

  return <StudentLayout isLoading={true}></StudentLayout>
}
